var _ellipse, _polygon, _text;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSrLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 65",
    width: 100,
    height: 65,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 32,
    rx: 38,
    ry: 27,
    fill: "#21335a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "80,32 98,15 98,49",
    fill: "#21335a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 42,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 28,
    fill: "#ffffff",
    letterSpacing: 2
  }, "SR")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrLogo);
export default __webpack_public_path__ + "static/media/SRLogo.6fb02c8f2b92fa17505abfb62b60be06.svg";
export { ForwardRef as ReactComponent };